import React from "react";

export const CartCheckMedia = (props: {
  color: string;
  tickMarkColor: string;
}) => (
  <div
    style={{
      outline: "1px solid #9e9e9e",
      borderRadius: "25px",
      height: "23px",
      width: "23px"
    }}
  >
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11.5" cy="11.5" r="11.5" fill={props.color} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7704 7.17451C20.1957 7.59991 20.1957 8.28961 19.7704 8.715L10.6599 17.8254C10.2345 18.2508 9.54482 18.2508 9.11943 17.8254L3.80501 12.511C3.37961 12.0856 3.37961 11.3959 3.80501 10.9705C4.2304 10.5451 4.9201 10.5451 5.3455 10.9705L9.88967 15.5147L18.2299 7.17451C18.6553 6.74912 19.345 6.74912 19.7704 7.17451Z"
        fill={props.tickMarkColor}
      />
    </svg>
  </div>
);
